/**
 * @generated SignedSource<<e3cf7253f074abdc55c85782e793e68c>>
 * @relayHash 157e01847edf9bec6a9fea5f7a61d7e7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 39d4822474993c4420ef32160533fe0a9fd90c354c47224d81a49f02138e4bd9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "39d4822474993c4420ef32160533fe0a9fd90c354c47224d81a49f02138e4bd9",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "jira",
            "issueByKey",
            "attachments"
          ]
        }
      ]
    },
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
